import { CcTokenizerClient } from '@anex/cc-tokenizer-client';
import { AnexApiClient } from '@anex/common';
import { AddressParser } from '../services/AddressParser';
import { AppStore, CheckAddressStore, DetailsStore, HardwareStore, PlanStore, SaleStore, SummaryStore, ConnectionDetailsStore, } from './';
var RootStore = (function () {
    function RootStore(config) {
        this.addressParser = new AddressParser();
        this.appStore = new AppStore();
        this.checkAddressStore = new CheckAddressStore(this);
        this.detailsStore = new DetailsStore(this);
        this.hardwareStore = new HardwareStore(this);
        this.planStore = new PlanStore(this);
        this.summaryStore = new SummaryStore(this);
        this.saleStore = new SaleStore(this);
        this.connectionDetailsStore = new ConnectionDetailsStore(this);
        this.config = config;
        this.api = new AnexApiClient(config.anexApiBaseUrl, config.anexApiToken);
        this.ccTokenizerClient = new CcTokenizerClient({
            authTokenEndpoint: config.anexApiBaseUrl + "/api/v1/credit-card/auth-token",
            bPointBaseUrl: config.bPointBaseUrl,
            eWayBaseUrl: config.eWayBaseUrl,
        });
    }
    return RootStore;
}());
export { RootStore };
//# sourceMappingURL=RootStore.js.map